import React, { useRef } from 'react';
import ReactDom from 'react-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { merge, get } from 'lodash';
import { CSSTransition } from 'react-transition-group';
import Button from '../Button';
import Item from '../Item';
import Icon from '../Icon';
import closeIcon from './images/close-modal.svg';

const baseModalStyle = {
  overlay: {
    backgroundColor: 'rgba(27, 29, 31, 0.5)'
  },
  content: {
    bottom: 'auto',
    border: 'none',
    background: '#FFF',
    outline: 'none',
    padding: '0px',
    width: '700px',
    maxHeight: window.innerHeight - 100
  }
};

// triky way to generate the doc
// https://react-styleguidist.js.org/docs/thirdparties/#how-styleguidist-works
export function SideModal(props) {
  const {
    title,
    children,
    footer,
    handleCancel,
    handleEnsure,
    btnCancelTxt,
    btnEnsureTxt,
    style,
    closable,
    width,
    className,
    isOpen,
    size,
    btnMini,
    containerUtil,
    ...other
  } = props;
  const classes = classNames(className, 'side-modal-content');
  const styles = merge({}, baseModalStyle, style);
  const ref = useRef();

  containerUtil.getContainer = () => {
    return ref.current;
  };

  const sizeWidth = {
    mini: 300,
    normal: 450,
    large: 550
  }[size];

  const resultWidth = width || sizeWidth;

  styles.content.width = get(style, 'content.width') || resultWidth;

  return (
    <CSSTransition in={isOpen} timeout={300} classNames="side-modal">
      <div className="side-modal" style={styles.overlay} onClick={handleCancel}>
        <CSSTransition
          in={isOpen}
          timeout={300}
          classNames="side-modal-content"
        >
          <div
            className={`${classes}`}
            style={styles.content}
            {...other}
            onClick={e => e.stopPropagation()}
          >
            <Item show={title}>
              <div className="side-modal-header">
                {title}
                <Item show={closable}>
                  <Icon
                    mini
                    className="close-icon"
                    onClick={handleCancel}
                    link={closeIcon}
                  />
                </Item>
              </div>
            </Item>
            <div className="side-modal-body" ref={ref}>
              {children}
            </div>
            <div className="side-modal-footer">
              {!footer ? (
                <div className="footer-btn-wrap">
                  <Button type="white" mini={btnMini} onClick={handleCancel}>
                    {btnCancelTxt}
                  </Button>
                  <Button type="primary" mini={btnMini} onClick={handleEnsure}>
                    {btnEnsureTxt}
                  </Button>
                </div>
              ) : (
                footer
              )}
            </div>
          </div>
        </CSSTransition>
      </div>
    </CSSTransition>
  );
}

export default props => {
  return ReactDom.createPortal(<SideModal {...props} />, document.body);
};

SideModal.defaultProps = {
  closable: true,
  btnCancelTxt: '取消',
  btnEnsureTxt: '确定',
  btnMini: true,
  size: 'large',
  containerUtil: {}
};
SideModal.propTypes = {
  /** 弹框标题，可以是string, 也可以是节点 */
  title: PropTypes.any,
  /** 自定义底部按钮，假设进行自定义，需要手动为按钮绑定回调事件 */
  footer: PropTypes.any,
  /** 是否展示关闭按钮 */
  closable: PropTypes.bool,
  /** 控制弹窗的展示状态 */
  isOpen: PropTypes.bool,
  /** 取消的回调事件 */
  handleCancel: PropTypes.func,
  /** 确定的回调事件 */
  handleEnsure: PropTypes.func,
  /** 修改取消按钮的内容 */
  btnCancelTxt: PropTypes.any,
  /** 修改确定按钮的内容 */
  btnEnsureTxt: PropTypes.any,
  /** 按钮是否是mini形式 */
  btnMini: PropTypes.bool,
  /** 自定义宽度 */
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /** 三种大小的弹框, 300px, 450px, 550px */
  size: PropTypes.oneOf(['mini', 'normal', 'large']),
  /**
   * 样式设定
   * {
   *   overlay: 蒙版,
   *   content: 内容
   * }
   */
  style: PropTypes.object,
  /**传入一个对象，会默认注入getContainer方法 */
  containerUtil: PropTypes.object
};
